// Styles for JoinBanner go here.
import styled from 'styled-components';
import rtl from 'styled-components-rtl';

export const StyledJoinBanner = styled.div`
  ${rtl`
  overflow: hidden;
  `}
`;
